<template>
    <v-card-text class="narrow-container">
        <v-text-field
            ref="twoFARecoveryCode"
            v-model="twoFARecovery.code"
            :error-messages="twoFARecovery.$errors.code"
            label="Enter recovery code"
            outlined
            type="text"
            @blur="twoFARecovery.validate('code')"
            @input="delete twoFARecovery.$errors.code"
            @keyup.native.enter="on2FARecoveryLogin"
        />

        <v-btn block color="primary" depressed large rounded @click="on2FARecoveryLogin" class="mb-12">
            Log In
        </v-btn>

        <router-link :to="{ name: 'LoginWith2FA', params: { email, password } }" class="frontpage-link text-center d-block text-decoration-underline">
            Go back
        </router-link>
    </v-card-text>
</template>

<script>
import * as rules from "vuelidate/lib/validators";

export default {
    name: "LoginWith2FARecovery",

    created() {
        if (!this.$route.params.email || !this.$route.params.password) {
            this.$router.push({ name: 'login' });
        }

        this.email = this.$route.params.email;
        this.password = this.$route.params.password;

        this.$nextTick(() => {
            this.$refs.twoFARecoveryCode.$el.querySelector('input').focus();
        });
    },

    data() {
        return {
            email: null,
            password: null,
            twoFARecovery: new Form(this, 'twoFARecovery', {
                code: null,
            }),
        }
    },

    validations: {
        twoFARecovery: {
            code: { required: rules.required, minLength: rules.minLength(10) },
        }
    },

    methods: {
        async on2FARecoveryLogin() {
            if (!this.twoFARecovery.validate()) {
                return;
            }

            let response = await this.$store.dispatch('Auth/login2FA', {
                one_time_password: this.twoFARecovery.code,
                email: this.email,
                password: this.password,
                recovery: 1
            })

            if (response?.status == 403) {
                this.$snackbar(`Incorrect recovery code.`, "error");
                this.twoFARecovery.code = '';
            }
        },
    }
}
</script>